export interface JsonWebToken {
  accessToken: string;
  email?: string;
  expires: number;
  id: string;
  user?: string;
  name: string;
  roles: string[];
}
